import React from 'react';
export function Footer() {
  return <footer id="contact" className="bg-avm-footer border-t border-avm-accent/30 pt-24 pb-12 px-6 md:px-12" data-id="element-28">
      <div className="max-w-7xl mx-auto" data-id="element-29">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-24" data-id="element-30">
          <div data-id="element-31">
            <img src="https://cdn.magicpatterns.com/uploads/1Wt6xZ2CEnACLmcpPMDgdq/pasted-image.jpg" alt="AVM Logo" className="h-12 object-contain logo-blend opacity-90 mb-8" data-id="element-32" />
            <h4 className="font-serif text-2xl text-avm-text mb-4" data-id="element-33">
              Atlas Ventures Management LLC
            </h4>
            <p className="text-avm-textMuted font-light max-w-sm" data-id="element-34">
              Building and operating technology-first businesses within
              traditional industries.
            </p>
          </div>

          <div className="flex flex-col md:items-end justify-center" data-id="element-35">
            <span className="text-avm-textMuted text-sm font-medium tracking-widest uppercase mb-4 block" data-id="element-36">
              Get in Touch
            </span>
            <a href="mailto:hello@atlasvmgmt.com" className="font-serif text-3xl md:text-4xl text-avm-text hover:text-avm-accent transition-colors duration-300 border-b border-avm-accent/30 hover:border-avm-accent pb-2" data-id="element-37">
              hello@atlasvmgmt.com
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-avm-border text-xs text-avm-textMuted/60 font-medium tracking-wide" data-id="element-38">
          <p data-id="element-39">© 2026 Atlas Ventures Management LLC. All rights reserved.</p>
          <div className="flex gap-6 mt-4 md:mt-0" data-id="element-40">
            <a href="#" className="hover:text-avm-text transition-colors" data-id="element-41">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-avm-text transition-colors" data-id="element-42">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}